import { InputAdornment, TextField, Typography, withStyles } from "@material-ui/core";
import { useState } from "react"
import BgLeft from '../assets/bgleftPass.svg';
import Bg from '../assets/bgrightPass.svg';
import LogoLogin from '../assets/LogoLogin.png';
import Forgot from '../assets/bg_forgot.png';
import Username from '../assets/ic_un.png';
import { useHistory } from "react-router-dom";
import api from './api';
import Constant from "../library/Constant";

const InputBaru = withStyles({
    root: {
        '& .MuiInputBase-input': {
            fontFamily: 'Poppins',
            fontSize: '1.4vh',
            fontWeight: '500',
            boxSizing: 'border-box'
        },
        '& .MuiOutlinedInput-input': {
            padding: '2vh 1vh'
        },
    }
})(TextField);

export default function ForgotPass(props) {
    const history = useHistory()

    const [showPass, setShowPass] = useState(false)
    const [email, setEmail] = useState("")

    const handleSubmit = () => {
        let payload = {
            "email": email
        }
        api.create().forgotPass(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    alert(response.data.message)
                } else {
                    if (response.data.data) {
                        if (response.data.data.email) {
                            alert(response.data.data.email)
                        }
                    }
                }
            }
        })
    }

    return (
        <div style={{ height: '100vh', display: 'flex', backgroundColor: '#278863', width: '100%' }}>
            <img src={BgLeft} style={{ position: 'absolute', left: 0, bottom: 0, width: '47%' }} />
            <img src={Bg} style={{ position: 'absolute', right: 0, bottom: 0, width: '30%' }} />
            <div style={{ width: '100%', height: '100%' }}>
                <div style={{ width: '100%', height: '20%', display: 'flex', padding: '2%', justifyContent: 'space-between', paddingLeft: '3%', paddingRight: '3%' }}>
                    <div style={{ display: 'flex', contain: 'layout' }}>
                        <img src={localStorage.getItem(Constant.LOGO_RS)} style={{ height: 80, width: 65, marginRight: 20, marginTop: 25 }} />
                        <div className='text-logo' style={{ alignSelf: 'center' }}>
                            <Typography style={{ fontSize: 46, fontWeight: 'bold', color: 'white', lineHeight: 1 }}>{localStorage.getItem(Constant.NAMA_RS)}</Typography>
                            <Typography style={{ fontSize: 20, fontWeight: '300', color: 'white' }}>{localStorage.getItem(Constant.DESCRIPTION_RS)}</Typography>
                        </div>
                    </div>
                    <button
                        onClick={() => history.goBack()}
                        style={{ backgroundColor: '#176f4d', height: '4vh', width: '7%', borderRadius: '4vh', alignItems: 'center', display: 'grid', cursor: 'pointer', outline: 'none', borderColor: 'transparent' }}>
                        <Typography style={{ color: '#fff', fontSize: '1vw', textAlign: 'center' }}>Login </Typography>
                    </button>
                </div>
                <div style={{ width: '100%', height: '80%', display: 'grid', justifyItems: 'center' }}>
                    <div style={{ width: '45%', height: '90%', backgroundColor: '#e8ffed', contain: 'layout', borderRadius: '4vh' }}>
                        <div style={{ width: '100%', height: '100%', textAlign: 'center', padding: '3%' }}>
                            <img src={Forgot} style={{ height: '28vh', width: '28vh', contain: 'layout' }} />
                            <Typography style={{ color: '#278863', fontSize: '2vw', textAlign: 'center' }}>Lupa Kata Sandi ? </Typography>
                            <div style={{ display: 'grid', width: '100%', justifyItems: "center", marginTop: '2%' }}>
                                <Typography style={{ color: 'black', fontSize: '1vw', textAlign: 'center', width: '50%' }}>Masukan Email atau No. Handphone anda untuk merubah kata sandi !</Typography>
                            </div>
                            <div style={{ marginTop: '4%', width: '100%' }}>
                                <InputBaru
                                    // label={<Typography style={{ fontSize: '1vw', fontFamily: 'Poppins' }}>Username (NIK)</Typography>}
                                    id="email"
                                    type={"text"}
                                    name={"email"}
                                    placeholder={'Email'}
                                    // value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                    }}
                                    variant="outlined"
                                    // error={errorEmail}
                                    style={{ width: '60%', fontSize: '1vw', borderRadius: 30, padding: 0 }}
                                    // helperText={msgEmail}
                                    InputProps={{
                                        style: { borderRadius: '3vh', height: '8%', backgroundColor: 'white', borderColor: '#278863', borderStyle: 'solid', borderWidth: '.4vh', maxHeight: 40, fontSize: '1vw', padding: 0 },
                                        startAdornment: <InputAdornment position="end" style={{ marginRight: '10%', height: '10%' }}><img src={Username} style={{ height: '3vh' }} /></InputAdornment>,
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            marginLeft: '15%',
                                            padding: 0
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ width: '100%', display: 'grid', justifyItems: 'center' }}>
                                <button
                                    onClick={() => handleSubmit()}
                                    style={{ backgroundColor: '#176f4d', height: '4vh', width: '25%', borderRadius: '4vh', alignItems: 'center', display: 'grid', cursor: 'pointer', outline: 'none', borderColor: 'transparent', marginTop: '6%' }}>
                                    <Typography style={{ color: '#fff', fontSize: '1vw', textAlign: 'center' }}>Submit </Typography>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}